jQuery(document).on('click', '.backtop-btn', function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, 300);
});


jQuery(function ($) {
  $('.table-top-wrap').on('click', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var $wrap = $btn.closest('.table-container').find('.table-map-wrap');

    if ($wrap.is(':animated')) return;

    if (!$wrap.hasClass('open')) {

      // Show
      $wrap.css('visibility', 'visible');
      $wrap.css('height', 'auto');
      var autoH = $wrap.height();
      $wrap.height(0);

      $wrap.animate({ height: autoH, opacity: 1 }, 300, function () {
        $wrap.css('height', 'auto').addClass('open');
      });

      // Add class to anchor
      $btn.addClass('active');

    } else {

      // Hide
      $wrap.removeClass('open').animate({ height: 0, opacity: 0 }, 300, function () {
        $wrap.css('visibility', 'hidden');
      });

      // Remove class from anchor
      $btn.removeClass('active');
    }
  });
});

// Logo Carousel
$(document).ready(function () {
  var $logoCarousel = $('.logo-carousel');

  if ($logoCarousel.length && !$logoCarousel.hasClass('owl-loaded')) {

    $logoCarousel.owlCarousel({
      items: 5,
      center: true,
      loop: true,
      nav: false,
      dots: false,
      margin: 0,
      stagePadding: 60,
      autoplay: false,
      autoplayTimeout: 2000,
      touchDrag: true,
      mouseDrag: true,

      responsive: {
        0: {
          items: 2,
          margin: 20,
          stagePadding: 0,
          touchDrag: true,
          mouseDrag: true,
          autoplay: false
        },
        600: {
          items: 3,
          margin: 20,
          stagePadding: 30
        },
        992: {
          items: 4,
          margin: 20
        },
        1200: {
          items: 5,
          stagePadding: 0
        }
      }
    });

    $(".logo-next").click(function () {
      $logoCarousel.trigger("next.owl.carousel");
    });

    $(".logo-prev").click(function () {
      $logoCarousel.trigger("prev.owl.carousel");
    });

  }

  // Product Slider
  var $productSlider = $('.product-slider-inner-dummy.owl-carousel');

  if ($productSlider.length && !$productSlider.hasClass('owl-loaded')) {

    $productSlider.owlCarousel({
      loop: true,
      margin: 20,
      nav: true,
      dots: false,
      autoplay: false,
      autoplayTimeout: 3000,
      responsive: {
        0: { items: 1 },
        768: { items: 1 },
        1023: { items: 2 },
        1201: { items: 3 },
        1600: { items: 3 }
      }
    });

  }

});



$('.logo-carousel').on('initialized.owl.carousel changed.owl.carousel refreshed.owl.carousel', function (event) {
  setTimeout(function () {

    // Scoped to logo carousel only
    const $carousel = $('.logo-carousel');
    const items = $carousel.find('.owl-item'); // ← scoped with .find()
    const activeItems = items.filter('.active');

    // Remove previous active-X, before-, after- classes
    items.removeClass(function (index, className) {
      return (className.match(/(^|\s)(active-\d|before-active-1|after-active-5)/g) || []).join(' ');
    });

    // Assign active-1 to active-5
    activeItems.each(function (index) {
      $(this).addClass('active-' + (index + 1));
    });

    // Add before-active-1
    const active1 = items.filter('.active-1');
    active1.prev('.owl-item').addClass('before-active-1');

    // Add after-active-5
    const active5 = items.filter('.active-5');
    active5.next('.owl-item').addClass('after-active-5');

  }, 10);
});


window.addEventListener('scroll', function () {
  const header = document.querySelector('.main-header');
  if (window.scrollY > 100) {
    header.classList.add('scroll');
  } else {
    header.classList.remove('scroll');
  }
});

$(document).ready(function () {
  var path = window.location.pathname;
  var slug = path === "/" ? "home" : path.split('/').filter(Boolean).pop().toLowerCase();
  $('body').addClass(slug);
});

jQuery.fn.isInViewport = function () {
  var elementTop = jQuery(this).offset().top;
  var elementBottom = elementTop + jQuery(this).outerHeight();
  var viewportTop = jQuery(window).scrollTop();
  var viewportBottom = viewportTop + jQuery(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// Initial word wrapping
function wrapWordsWithSpans(selector) {
  jQuery(selector).each(function () {
    let text = jQuery(this).text().trim();
    let words = text.split(" ");
    jQuery(this).html(words.map(word => `<span class="word">${word} </span>`).join(""));
  });
}

// Scroll-based color application
function updateWordColors() {
  jQuery(".rich-text.content-container p").each(function () {
    if (!jQuery(this).data("wrapped")) {
      wrapWordsWithSpans(this);
      jQuery(this).data("wrapped", true);
    }

    if (jQuery(this).isInViewport()) {
      let words = jQuery(this).find("span.word");
      let elTop = jQuery(this).offset().top;
      let scrollTop = jQuery(window).scrollTop();
      let windowHeight = jQuery(window).height();

      let scrollProgress = (scrollTop + windowHeight - elTop) / windowHeight;
      scrollProgress = Math.min(Math.max(scrollProgress, 0), 1); // Clamp between 0 and 1

      let wordsToColor = Math.floor(scrollProgress * words.length);

      words.each(function (index) {
        if (index < wordsToColor) {
          jQuery(this).css("color", "#FFFFFF");
        } else {
          jQuery(this).css("color", "#5E5E5E");
        }
      });
    }
  });
}

// Bind to scroll
jQuery(window).on("scroll", function () {
  updateWordColors();
});

// Optionally run on load too
jQuery(window).on("load", function () {
  updateWordColors();
});



// jQuery.fn.isInViewport = function () {
//     var elementTop = jQuery(this).offset().top;
//     var elementBottom = elementTop + jQuery(this).outerHeight();
//     var viewportTop = jQuery(window).scrollTop();
//     var viewportBottom = viewportTop + jQuery(window).height();

//     return elementBottom > viewportTop && elementTop < viewportBottom;
// };

// function animateTextColor(selector, startColor, endColor, duration) {
//     let element = jQuery(selector);
//     let text = element.text().trim();
//     let letters = text.split("");

//     element.html(letters.map((letter) => `<span>${letter}</span>`).join(""));

//     let spans = element.find("span");
//     let interval = duration / letters.length;

//     spans.css("color", startColor);

//     spans.each(function (index) {
//         setTimeout(() => {
//             jQuery(this).css({
//                 transition: `color ${interval / 1000}s ease`,
//                 color: endColor,
//             });
//         }, index * interval);
//     });
// }

// let animationTriggered = false;

// jQuery(window).on("resize scroll", function () {
//     if (!animationTriggered) {
//         var elementsInViewport = jQuery(".rich-text.content-container p").filter(function () {
//             return jQuery(this).isInViewport();
//         });

//         if (elementsInViewport.length > 0) {
//             animateTextColor(".rich-text.content-container p", "#5E5E5E", "#FFFFFF", 6000);
//             animationTriggered = true;
//         }
//     }
// });

$(document).ready(function () {
  $('.menu-drawer-container .header__icon--menu').on('click', function () {
    $('html').toggleClass('drawer-menu-active');
  });
});

// play vidoe in slow motion
document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll('.slow-motion-video');
  videos.forEach(video => {
    video.playbackRate = 0.5; // Slower speed (0.5x = half speed)
  });
});

// play vidoe in slow motion end


// custom popup js start

// JavaScript to handle popup and load Klaviyo form
document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById("openPopup");
  const popup = document.getElementById("popupForm");

  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    popup.style.display = "block";
    // document.documentElement.classList.add("popup-open");

    // Load Klaviyo form
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'TTcVDy']); // Replace with your real form ID
  });


});



// Removed outside click closing

// custom popup js end


//Video play product page
document.addEventListener("DOMContentLoaded", function () {
  const section = document.currentScript.closest(".custom-video-wrapper");
  const video = section.querySelector(".custom-video");
  const overlay = section.querySelector(".video-overlay");

  overlay.addEventListener("click", () => {
    video.play();
    overlay.style.display = "none";
  });
});

// Product Gallery slider and testimonials
$(document).ready(function () {

  // community logos Carousel 
  $(".logos").owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 1000,
    touchDrag: false,
    mouseDrag: false,
    responsive: {
      0: {
        items: 1,
        touchDrag: true,
        mouseDrag: true,
        autoplay: false,
      },
      600: {
        items: 4
      },
      992: {
        items: 5
      },
      1037: {
        items: 7
      },

      1661: {
        items: 10
      }

    }
  });





  // Testimonials Carousel (small padding)
  $(".gallery").owlCarousel({
    loop: true,
    margin: 25,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    touchDrag: true,
    mouseDrag: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        touchDrag: true,
        mouseDrag: true,
        autoplay: false,
      },
      600: {
        items: 2
      },
      992: {
        items: 3
      }
      ,
      1037: {
        items: 4
      },

      1661: {
        items: 5
      }

    }
  });



  // Gallery Carousel (larger padding)
  $(".testimonial").owlCarousel({
    loop: true,
    margin: 15,
    nav: false,
    dots: false,
    autoplay: false,
    autoplayTimeout: 3000,
    touchDrag: true,
    mouseDrag: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        autoplay: false,
        touchDrag: true,
        mouseDrag: true,
      },
      600: {
        items: 1
      },
      992: {
        items: 2
      },
      1037: {
        items: 2
      },

      1661: {
        items: 2
      }

    }
  });

  $(".team-carousel").owlCarousel({
    loop: true,
    margin: 15,
    nav: false,
    dots: true,
    autoplay: false,
    autoplayTimeout: 3000,
    touchDrag: true,
    mouseDrag: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        autoplay: false,
        touchDrag: true,
        mouseDrag: true,
      },
      600: {
        items: 2
      },
      992: {
        items: 3
      },
      1037: {
        items: 3
      }

    }
  });


  $(document).ready(function () {
    var $inner = $('.collection-inner');
    var owlActive = false;

    function initOwl() {
      if ($(window).width() <= 767 && !owlActive) {
        $inner.addClass('owl-carousel owl-theme');
        $inner.owlCarousel({
          items: 1,
          loop: true,
          dots: true,
          nav: false,
          autoplay: false,
          margin: 0,
          responsive: {
            480: { items: 1 },
            700: { items: 2 }
          }
        });
        owlActive = true;
      } else if ($(window).width() > 767 && owlActive) {
        $inner.trigger('destroy.owl.carousel');
        $inner.removeClass('owl-carousel owl-theme owl-loaded owl-drag');
        $inner.find('.owl-stage-outer').children().unwrap();
        owlActive = false;
      }
    }

    initOwl();
    $(window).on('resize', initOwl);
  });

  // Community Testmonials slider
  $(".community-slider").owlCarousel({
    loop: true,
    margin: 15,
    nav: true,
    dots: false,
    autoplay: false,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0707/2448/5292/files/new-left.png?v=1758283487' alt='Prev'>",
      "<img src='https://cdn.shopify.com/s/files/1/0707/2448/5292/files/new-right.png?v=1758283487' alt='Next'>"

    ],
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 }
    },
  });


});

// Specs Accordion
document.querySelectorAll(".specs-accordion").forEach(accordion => {
  const items = accordion.querySelectorAll(".specs-accordion-item");
  const headers = accordion.querySelectorAll(".specs-accordion-header");

  items.forEach(item => item.classList.remove("active"));

  headers.forEach(header => {
    header.addEventListener("click", function () {
      const item = this.parentElement;

      if (item.classList.contains("active")) {

        item.classList.remove("active");
      } else {

        items.forEach(i => i.classList.remove("active"));

        item.classList.add("active");
      }
    });
  });
});







document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.custom-video-wrapper');
  const popup = document.querySelector('.video-popup');
  const closeBtn = document.querySelector('.video-popup-close');
  const video = popup?.querySelector('video');

  if (!wrapper || !popup) return;

  wrapper.addEventListener('click', function () {
    popup.style.display = 'flex';
    if (video) video.play();
  });

  closeBtn?.addEventListener('click', function () {
    popup.style.display = 'none';
    if (video) {
      video.pause();
      video.currentTime = 0; // optional: reset
    }
  });

  popup.addEventListener('click', function (e) {
    // click outside video area closes too
    if (e.target === popup) {
      popup.style.display = 'none';
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  });
});

/*
document.addEventListener("DOMContentLoaded", function() {
  // Replace with your product handle
  const productHandle = "chasm-polarized-fly-fishing-sunglasses"; 

  // New redirect URL
  const customPage = "https://www.marblefishing.com/pages/product-shop";

  // Update all links that point to this product
  document.querySelectorAll(`a[href*="/products/${productHandle}"]`).forEach(function(link) {
    link.setAttribute("href", customPage);
  });
});
*/

//Button click popup product page

document.addEventListener("DOMContentLoaded", function () {

  const popupButtons = document.querySelectorAll(".openPopupBtn");

  popupButtons.forEach((btn) => {

    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const popup = btn.nextElementSibling;
      const popupBox = popup.querySelector(".popup-box");

      // Reset classes on each open
      popupBox.classList.remove(
        "no-image",
        "no-title",
        "no-description",
        "image-only",
        "text-only"
      );

      // --- Image ---
      const imageUrl = btn.getAttribute("data-image");
      const popupImg = popup.querySelector(".popup-image");
      if (popupImg) {
        if (imageUrl) {
          popupImg.src = imageUrl;
          popupImg.style.display = "block";
        } else {
          popupImg.src = "";
          popupImg.style.display = "none";
          popupBox.classList.add("no-image");
        }
      }

      // --- Title ---
      const title = btn.getAttribute("data-title");
      const popupTitle = popup.querySelector(".popup-title");
      if (popupTitle) {
        if (title) {
          popupTitle.textContent = title;
          popupTitle.style.display = "block";
        } else {
          popupTitle.textContent = "";
          popupTitle.style.display = "none";
          popupBox.classList.add("no-title");
        }
      }

      // --- Description ---
      const description = btn.getAttribute("data-description");
      const popupDesc = popup.querySelector(".popup-description");
      if (popupDesc) {
        if (description) {
          popupDesc.textContent = description;
          popupDesc.style.display = "block";
        } else {
          popupDesc.textContent = "";
          popupDesc.style.display = "none";
          popupBox.classList.add("no-description");
        }
      }

      // --- Combo layout classes ---
      const hasImage = !!imageUrl;
      const hasTitle = !!title;
      const hasDesc = !!description;

      if (hasImage && !hasTitle && !hasDesc) {
        popupBox.classList.add("image-only");
      }
      if (!hasImage && (hasTitle || hasDesc)) {
        popupBox.classList.add("text-only");
      }

      popup.classList.add("active");

      // --- Close button ---
      const closeBtn = popup.querySelector(".closePopupBtn");
      closeBtn.addEventListener("click", function () {
        popup.classList.remove("active");
      });

      // --- Click outside ---
      popup.addEventListener("click", function (e) {
        if (e.target === popup) {
          popup.classList.remove("active");
        }
      });

    });

  });

});



// new product page new accordion
document.addEventListener("DOMContentLoaded", function () {

  const items = document.querySelectorAll(".acc-item");

  if (!items.length) return;

  items.forEach((item) => {

    const header = item.querySelector(".acc-header");
    const content = item.querySelector(".acc-content");

    // Skip broken items
    if (!header || !content) return;

    // Open active accordion initially
    if (item.classList.contains("active")) {
      content.style.maxHeight = content.scrollHeight + "px";
    }

    header.addEventListener("click", function () {

      const isFirst = item.classList.contains("first-acc");

      // Prevent closing first accordion
      if (isFirst) return;

      const isActive = item.classList.contains("active");

      // Close others
      items.forEach((it) => {

        if (it !== item && !it.classList.contains("first-acc")) {

          const otherContent = it.querySelector(".acc-content");

          it.classList.remove("active");

          if (otherContent) {
            otherContent.style.maxHeight = "0px";
          }
        }
      });

      // Toggle current
      if (!isActive) {

        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";

      } else {

        item.classList.remove("active");
        content.style.maxHeight = "0px";
      }

    });

  });

});



// New product page Photo gallery popup

document.querySelector(".open-popup").addEventListener("click", function () {
  document.querySelector(".custom-popup").style.display = "flex";
});

// Close popup
document.querySelector(".popup-close").addEventListener("click", function () {
  document.querySelector(".custom-popup").style.display = "none";
});

// ONLY VERTICAL DRAG SCROLL
const scrollArea = document.querySelector(".drag-scroll");
let isDragging = false;
let startY;
let initialScrollTop;

scrollArea.addEventListener("mousedown", (e) => {
  isDragging = true;
  scrollArea.classList.add("dragging");
  startY = e.pageY;                     // start position Y only
  initialScrollTop = scrollArea.scrollTop;
});

scrollArea.addEventListener("mouseup", () => {
  isDragging = false;
  scrollArea.classList.remove("dragging");
});

scrollArea.addEventListener("mouseleave", () => {
  isDragging = false;
  scrollArea.classList.remove("dragging");
});

scrollArea.addEventListener("mousemove", (e) => {
  if (!isDragging) return;
  e.preventDefault();

  const y = e.pageY;
  const moveY = (y - startY) * 2;       // drag speed multiplier
  scrollArea.scrollTop = initialScrollTop - moveY;
});

// IMAGE CLICK TO OPEN FULLSCREEN
document.querySelectorAll(".gallery-one img").forEach((img) => {
  img.addEventListener("click", () => {
    // Create overlay if it doesn't exist
    let overlay = document.querySelector(".image-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "image-overlay";
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        cursor: zoom-out;
      `;
      document.body.appendChild(overlay);

      // Click overlay to close
      overlay.addEventListener("click", () => {
        overlay.style.display = "none";
        overlay.innerHTML = "";
      });
    }

    // Show clicked image in overlay
    const enlargedImg = document.createElement("img");
    enlargedImg.src = img.src;
    enlargedImg.style.maxWidth = "90%";
    enlargedImg.style.maxHeight = "90%";
    overlay.innerHTML = ""; // remove previous image
    overlay.appendChild(enlargedImg);
    overlay.style.display = "flex";
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const lensColorWrap = document.querySelector(".lens-color");
  const lensSelect = document.getElementById("lens-finish");

  function updateLensColorClass() {
    const selectedIndex = lensSelect.selectedIndex;

    // Remove previous classes
    lensColorWrap.classList.remove("color1", "color2");

    // Add class based on selected index (0 = first option, 1 = second option)
    if (selectedIndex === 0) {
      lensColorWrap.classList.add("color1");
    } else if (selectedIndex === 1) {
      lensColorWrap.classList.add("color2");
    }
  }

  // Run on load
  updateLensColorClass();

  // Run on change
  lensSelect.addEventListener("change", updateLensColorClass);
});


